import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const home = user?.role === "client" ? "/portal" : "/business";

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch (e) { /* keep trying */ }
      if (tries++ < 8) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-5">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-10 text-center" data-testid="payment-success-card">
        {status === "checking" && (<><Loader2 className="mx-auto h-10 w-10 animate-spin text-brand" /><p className="mt-4 font-medium text-slate-900">Confirming your subscription…</p></>)}
        {status === "paid" && (<><CheckCircle2 className="mx-auto h-12 w-12 text-green-500" /><h1 className="mt-4 font-heading text-2xl font-bold text-slate-900">Payment confirmed!</h1><p className="mt-2 text-sm text-slate-500">All done. Thank you.</p><Button onClick={() => navigate(home)} className="mt-6 w-full rounded-full bg-brand hover:bg-brand-hover" data-testid="payment-continue-btn">Continue</Button></>)}
        {(status === "error" || status === "timeout") && (<><XCircle className="mx-auto h-12 w-12 text-amber-500" /><p className="mt-4 font-medium text-slate-900">{status === "timeout" ? "Still processing — this can take a moment." : "We couldn't confirm this payment."}</p><Button onClick={() => navigate(home)} className="mt-6 w-full rounded-full bg-brand hover:bg-brand-hover" data-testid="payment-back-btn">Go back</Button></>)}
      </div>
    </div>
  );
}
